import { 
  ViewReturnsIntakeDetail, 
  ReturnsIntakeScanner,
  ReturnsIntakeScannerSummary,
  DriversWithOpenReturns,
  PendingShippingsWithReturnsIntake,
  NotReportedShippingsWithReturnsIntake
} from '../pages';
import { RouteObject } from 'react-router-dom';
import ReturnsIntake from '../ReturnsIntake';

const ReturnsIntakeRoutes: RouteObject[] = [
  {
    path: 'returns-intake',
    children: [
      {
        path: '',
        element: <ReturnsIntake />,
      },
      {
        path: 'scanner',
        element: <ReturnsIntakeScanner />,
      },
      {
        path: 'scanner/summary/:driverId',
        element: <ReturnsIntakeScannerSummary />,
      },
      {
        path: 'open-returns',
        element: <DriversWithOpenReturns />,
      },
      {
        path: 'pending-shippings',
        element: <PendingShippingsWithReturnsIntake />,
      },
      {
        path: 'not-reported-shippings',
        element: <NotReportedShippingsWithReturnsIntake />,
      },
      {
        path: 'by-driver/:driverId',
        element: <ViewReturnsIntakeDetail />,
      },
    ],
  },
];

export default ReturnsIntakeRoutes;
